import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { PosDataService } from "./pos.data.service";
import { ILocalizationLanguage } from "./model/pos.api.model";

@Injectable({
  providedIn: "root",
})
export class LanguageService {
  currentLanguage: string = "en";

  constructor(
    private translateService: TranslateService,
    private posDataService: PosDataService
  ) {}

  isLanguageSelected(): boolean {
    const lang = this.getCurrentLanguage();
    return lang ? true : false;
  }

  async setLanguage(lang: string, reload: boolean) {
    lang = this.mapLanguageToCode(lang);
    this.currentLanguage = lang;
    this.setLanguageToStorage(lang);

    const translation = await this.posDataService.getSelectedLanguage(lang);
    if (translation) {
      this.translateService.setTranslation(lang, translation, true);
      this.translateService.use(lang);
      if (reload) {
        this.reloadCurrentPage();
      }
    }
  }

  private mapLanguageToCode(lang: string): string {
    switch (lang) {
      case "cz":
      case "cs-CZ":
        return "cs";
      case "sk":
      case "sk-SK":
        return "sk";
      case "hu-HU":
        return "hu";
      default:
        return lang;
    }
  }

  async getAvailableLanguages(): Promise<ILocalizationLanguage[]> {
    return await this.posDataService.getAvailableLanguages();
  }

  getCurrentLanguage(): string {
    try {
      const language = JSON.parse(localStorage.getItem("selectedLanguage"));
      return language;
    } catch {
      return null;
    }
  }

  private setLanguageToStorage(lang: string) {
    localStorage.setItem("selectedLanguage", JSON.stringify(lang));
  }

  private reloadCurrentPage() {
    window.location.reload();
  }
}
